import { c as _c } from "react/compiler-runtime";
import { Item, ItemAvatar, ItemContent } from "@opensea/next-ui-kit";
import { Media, SkeletonBlock, SkeletonLine } from "@opensea/ui-kit";
import { CollectionMetadataChipsSkeleton } from "./CollectionMetadataChipsSkeleton";
import { collectionInfoVariants } from "./collection-info-variants";
export function CollectionInfoSkeleton(t0) {
  const $ = _c(23);
  const {
    variant: t1,
    headerView
  } = t0;
  const variant = t1 === undefined ? "on-background" : t1;
  let T0;
  let T1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== headerView || $[1] !== variant) {
    const {
      avatar,
      itemContent
    } = collectionInfoVariants({
      headerView
    });
    T1 = Item;
    t3 = "unstyled";
    let t5;
    if ($[7] !== variant) {
      t5 = <SkeletonBlock variant={variant} />;
      $[7] = variant;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = <ItemAvatar className={avatar()} size={80}>{t5}</ItemAvatar>;
    T0 = ItemContent;
    t2 = itemContent();
    $[0] = headerView;
    $[1] = variant;
    $[2] = T0;
    $[3] = T1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    T0 = $[2];
    T1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[9] !== variant) {
    t5 = <SkeletonLine className="h-5 w-40" variant={variant} />;
    $[9] = variant;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== variant) {
    t6 = <Media greaterThanOrEqual="md"><CollectionMetadataChipsSkeleton variant={variant} /></Media>;
    $[11] = variant;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== T0 || $[14] !== t2 || $[15] !== t5 || $[16] !== t6) {
    t7 = <T0 className={t2}>{t5}{t6}</T0>;
    $[13] = T0;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== T1 || $[19] !== t3 || $[20] !== t4 || $[21] !== t7) {
    t8 = <T1 variant={t3}>{t4}{t7}</T1>;
    $[18] = T1;
    $[19] = t3;
    $[20] = t4;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}